import { defineComponent as _defineComponent } from 'vue'
import { emptyList } from '@/services/api';
  import { CourseAuthorized, CoursesList } from '@/entities/trainings';
  import FilterForm from '@/ui/components/filters/horizontal/FilterForm.vue';
  import BulkDeleteButton from '@/ui/components/button/BulkDeleteButton.vue';
  import SearchFilter from '@/ui/components/filters/horizontal/SearchFilter.vue';
  import { BulkDeletableTable } from '@/ui/components/table/BulkDeletableTable';
  import { useBulkDeletable } from '@/ui/pages/useBulkDeletable';
  import * as qs from '@/ui/queryState';
  import { Pagination } from '@/ui/components/Pagination';
  import { ref, watch } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { Loader } from '@/ui/components/Loader';
  import { list as listCourses, bulkDelete, remove } from '@/services/api/resources/trainings';
  import { usePagination, useTask } from '@/ui/concerns';
  import { debounce } from 'lodash';
  import StartCourseModal from '@/ui/components/trainings/courseTake/StartCourseModal.vue';
  import { useStartCourseModal } from '@/ui/concerns/trainings/useStartCourseModal';
  import { Button } from '@/ui/components/Button';
  import ManageCoursesEmpty from '@/ui/pages/trainings/tabs/empty/ManageCoursesEmpty.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ManageCoursesTab',
  setup(__props) {

  const coursesList = ref<CoursesList>(emptyList());
  const search = qs.string('q', '');
  const { page, perPage, resetPagination } = usePagination();

  const getCourses = useTask(
    () => listCourses({
      page: page.value,
      perPage: perPage.value,
      search: search.value,
    }),
    result => {
      coursesList.value = result;
    },
  );

  watch([page, perPage, search], debounce(() => {
    getCourses.run();
  }, 100));

  const { selectedResources, deleteBulkTask, onCheckedRowsUpdate, isBulkDeletionDisabled } = useBulkDeletable({
    getList: getCourses,
    bulkDeleteFn: bulkDelete,
  });

  const canDeleteCourse = (course: CourseAuthorized) => course.authorizedTo.delete;

  const { isStartModalOpen, openStartCourse, closeStartModal, confirmStartCourse, courseToStart } = useStartCourseModal();

return { __sfc: true,coursesList, search, page, perPage, resetPagination, getCourses, selectedResources, deleteBulkTask, onCheckedRowsUpdate, isBulkDeletionDisabled, canDeleteCourse, isStartModalOpen, openStartCourse, closeStartModal, confirmStartCourse, courseToStart, FilterForm, BulkDeleteButton, SearchFilter, BulkDeletableTable, Pagination, Box, Loader, remove, StartCourseModal, Button, ManageCoursesEmpty }
}

})